export default __webpack_public_path__ + "static/media/575.2d88027c.png";